import type React from 'react'
import type { JSX, Ref } from 'react'
import type { TextBoxColors, TextBoxTypes } from 'atoms/TextBox'

import { Icon, IconSizes } from 'atoms/Icon'
import { IconNames } from 'atoms/Icon/Icon.h'
import { TextBox } from 'atoms/TextBox'
import { COLOR } from 'vars/index'
import { Background, BorderColors, Color, Corners } from './CheckBox.h'
import { Checkmark, Label } from './CheckBox.styled'

export interface ICheckboxProps {
  ref?: Ref<HTMLLabelElement>
  id: string
  name: string
  corners?: Corners
  borderColor?: BorderColors
  borderColorHovered?: BorderColors
  borderColorChecked?: BorderColors
  borderColorDisabled?: BorderColors
  color?: Color
  colorDisabled?: Color
  background?: Background
  backgroundHovered?: Background
  backgroundChecked?: Background
  backgroundDisabled?: Background
  checked?: boolean
  defaultChecked?: boolean
  disabled?: boolean
  className?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  label?: string
  labelFont?: TextBoxTypes
  labelColorDefault?: TextBoxColors
}

export function Checkbox({
  ref,
  id,
  name,
  corners = Corners.CORNERS_10,
  borderColor = BorderColors.TEXT_ICON_SECONDARY,
  borderColorHovered = BorderColors.ACCENT_SECONDARY,
  borderColorChecked = BorderColors.ACCENT_SECONDARY,
  borderColorDisabled = BorderColors.SURFACE_OPACITY_LIGHT_10,
  color = Color.TEXT_BUTTON_PRIMARY,
  colorDisabled = Color.SURFACE_OPACITY_LIGHT_10,
  background = Background.SURFACE_OPACITY_LIGHT_10,
  backgroundHovered = Background.SURFACE_OPACITY_LIGHT_10,
  backgroundChecked = Background.ACCENT_PRIMARY_GRADIENT,
  backgroundDisabled = Background.DISABLED,
  checked,
  defaultChecked,
  disabled = false,
  className = '',
  onChange,
  label,
  labelColorDefault,
  labelFont,
}: ICheckboxProps): JSX.Element {
  return (
    <Label
      ref={ref}
      htmlFor={id}
      className={className}
      colorDefault={color}
      colorDisabled={colorDisabled}
      backgroundHovered={backgroundHovered}
      borderColorHovered={borderColorHovered}
      borderColorChecked={borderColorChecked}
      borderColorDisabled={borderColorDisabled}
      backgroundChecked={backgroundChecked}
      backgroundDisabled={backgroundDisabled}
    >
      <TextBox title={label} font={labelFont} color={labelColorDefault} />
      <input
        type='checkbox'
        id={id}
        name={name}
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={onChange}
      />
      <Checkmark
        borderColor={borderColor}
        corners={corners}
        background={background}
      >
        <Icon
          name={IconNames.check}
          size={IconSizes.small}
          color={
            disabled
              ? COLOR.SURFACE_OPACITY_LIGHT_10
              : COLOR.TEXT_ICON_CONSTANT_LIGHT
          }
        />
      </Checkmark>
    </Label>
  )
}
